import React, { useEffect, useState } from "react";
import Loading from "../Modals/Loading";
import { useNavigate } from "react-router-dom";
import permissionService from "../Services/permissionService";
import { FiEdit3 } from "react-icons/fi";
import { HiOutlineTrash } from "react-icons/hi";
import Head from "../Components/Head";
import inventoryService from "../Services/inventoryService";

const Inventory = () => {
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        setLoading(true);
        const response = await inventoryService.fetchAllInventory();
        setPermissions(response.inventory);
        console.log(response.inventory);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    fetchPermissions();
  }, []);

  const navigate = useNavigate();

  // Function to toggle status
  const toggleStatus = async (id, currentStatus) => {
    try {
      setLoading(true);
      const newStatus = currentStatus === "active" ? "inactive" : "active"; // Toggle the status
      await permissionService.updateStatus(id, newStatus); // Make a request to update the status in the backend

      // Update the status locally after the request is successful
      setPermissions(permissions.map(permission =>
        permission.id === id ? { ...permission, status: newStatus } : permission
      ));
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Function to delete permission
  const deletePermission = async (id) => {
    try {
      setLoading(true);
      await permissionService.deletePermission(id); // Make a request to delete the permission from the backend

      // Remove the deleted permission from the list locally
      setPermissions(permissions.filter(permission => permission.id !== id));
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <Loading />
      ) : (
        <>
          <Head heading={"Inventory"} button_text={"Add Inventory"} navigation={() => navigate("/inventory/add")}/>
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 w-full text-black text-[10px] text-center">
                  <th className="py-4 w-[2%] text-left pl-4">ID</th>
                  <th className="py-4 w-[5%] text-left pl-4">Vendor Code</th>
                  <th className="py-4 w-[5%]">Brand</th>
                  <th className="py-4 w-[2%]">Qty</th>
                  <th className="py-4 w-[2%]">Weight</th>
                  <th className="py-4 w-[2%]">Purchase Price</th>
                  <th className="py-4 w-[5%]">Sale Price</th>
                  <th className="py-4 w-[2%]">Description</th>
                  <th className="py-4 w-[2%]">Delete</th>
                </tr>
              </thead>
              <tbody>
                {permissions.map((permission, index) => (
                  <tr key={index} className="bg-accent border-b border-gray-100 text-center">
                    <td className="py-4 w-[2%] text-left pl-4 font-bold text-blue-500">{permission.id}</td>
                    <td className="py-4 w-[5%] text-left pl-4 font-bold">{permission.v_code}</td>
                    <td className="py-4 w-[5%] font-bold">{permission.brand}</td>
                    <td className="py-4 w-[2%] font-bold">{permission.qty}</td>
                    <td className="py-4 w-[2%] font-bold">{permission.weight}</td>
                    <td className="py-4 w-[2%] font-bold">{permission.p_price}</td>
                    <td className="py-4 w-[5%] font-bold">{permission.sale_price}</td>
                     <td className="w-[2%]">
                      <div className='flex justify-center'>
                        <button onClick={() => navigate("/permission/edit?id=" + permission.id)}>
                          <FiEdit3 className="h-4 w-4 text-indigo-500"/>
                        </button>
                      </div>
                    </td>
                    <td className="w-[2%]">
                      <div className='flex justify-center'>
                        <button onClick={() => deletePermission(permission.id)}>
                          <HiOutlineTrash className="h-4 w-4 text-red-500"/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default Inventory;
